/**
 * A pasted secret without the whitespace a terminal copy adds — front, back or
 * inside (terminals wrap long tokens across lines). Also drops zero-width
 * characters, which `\s` misses. Mirrors the backend's `sanitize_secret`.
 */
export function withoutWhitespace(secret: string): string {
  return secret.replace(/[\s​-‍⁠]/g, "");
}
